import { render, staticRenderFns } from "./Ekg.vue?vue&type=template&id=36f03d96&scoped=true"
import script from "./Ekg.vue?vue&type=script&lang=ts"
export * from "./Ekg.vue?vue&type=script&lang=ts"
import style0 from "./Ekg.vue?vue&type=style&index=0&id=36f03d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f03d96",
  null
  
)

export default component.exports